import { render, staticRenderFns } from "./CantAddMoreUpdates.vue?vue&type=template&id=6dd3c6b2&"
import script from "./CantAddMoreUpdates.vue?vue&type=script&lang=js&"
export * from "./CantAddMoreUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports